import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getUserInfo } from '../../redux/selectors'
import MenuComponent from './MenuComponent'

class MenuContainer extends React.PureComponent {
  render () {
    return (
      <MenuComponent claims={this.props.claims} history={this.props.history} accountOwner={this.props.accountOwner} />
    )
  }
}

MenuContainer.propTypes = {
  userName: PropTypes.string,
  claims: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired
}

const mapStateToProps = state => {
  return {
    userName: getUserInfo(state).userName || '',
    claims: getUserInfo(state).claims || [],
    accountOwner: (getUserInfo(state).contact || {}).accountOwner || ''
  }
}

const MenuConnect = connect(mapStateToProps, null)(MenuContainer)

export default MenuConnect
